<template>
	<div v-cloak class="login" v-if="isAPI && !showDemo">
		<div id="body_show">
			<div class="gridContainer clearfix LoginEN">
				<div class="login_main">
					<div id="div_langx" name="div_langx" class="LayoutDiv tablet">
						<div style="margin-left: auto;margin-right: auto;height:75px">
							<img  style="margin-top:-20;width:90px" v-if="customTemplate && showLogo" :src="customTemplate['logo_home']">
						</div>
					</div>
					<div class="tablet_main">
						<div id="err_info" class="err_info" >
							<br>
							<center><font id="hr_info">{{ lang.sessionExipred }}</font></center>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="sysreq_show" class="sys" style="display: none;">
			<div class="title_sys">
				<div id="go_back" class="btn_back"><img id="irightarr" src="assets/images/icon_rightarr.svg"></div>
			</div>
			<div class="content_sys">
			</div>
		</div>
	</div>

	<div v-cloak class="login"  :lang="cookielang" v-else>
		<loadingScreen :loading="loading"></loadingScreen>
		<popupFestival></popupFestival>
		<popup v-if="popupFlag" :democreditLogin="popupFlag" :lang="lang" ></popup>
		<div id="notice_show"></div>
		<div id="body_show"  style="height:100vh">
			<div class="login_main">
				<div class="box_language">
					<span id="langx_zh-cn" name="langx_zh-cn" :class="langClass(langSelect[2].language_code)" @click="changeLanguage(2)">
					{{langSelect[2].caption}}版
					</span>
					<span id="langx_zh-tw" name="langx_zh-tw" :class="langClass(langSelect[3].language_code)" @click="changeLanguage(3)">
					{{langSelect[3].caption}}版
					</span>
					<span id="langx_en-us" name="langx_en-us" :class="langClass(langSelect[1].language_code)" @click="changeLanguage(1)">
					{{langSelect[1].caption}}
					</span>
				</div>
				<template v-if="!centerLogin">
					<i class="comp-logo" :class="defaultLogo()"><img v-if="customTemplate" :src="customTemplate['logo_mhg']"> </i>
				</template>
				<div class="box_login">
					<label id="usr_lab" class="lab_input">
					<input id="usr" class="userid" type="text" autocomplete="off" required="required" @click="input_Green(1)" :class="cookielang" v-model="formData.accname">
					<span class="text_input" :data-tooltip="lang.username_def"></span>
					<i id="usr_dele" class="btn_clear" data-system="ios12" @click="input_Clear(1)"><img src="assets/images/icon_close_b.svg"></i>
					</label>
					<label id="pwd_lab" class="lab_input">
					<input id="pwd" class="pwd" type="password" autocomplete="off" required="required" @click="input_Green(2)" :class="cookielang" v-model="formData.pass">
					<span class="text_input" :data-tooltip="lang.password_def"></span>
					<i id="pwd_dele" class="btn_clear" data-system="ios12" @click="input_Clear(2)"><img src="assets/images/icon_close_b.svg"></i>
					</label>
					<span id="text_error" class="text_error" v-show="error.loginIdReq">
					{{ error.message }}
					</span>
					<div>
						<div id="login_btn" class="btn_login" @click.prevent="login">{{ lang.login }}</div>
					</div>
					<div v-if="showDemo && isAPI">
						<div id="btn_login_demo" class="btn_login" @click.prevent="demoLogin">{{ lang.demo }}</div>
					</div>
					<div v-if="showCreditDemoFlag && !isAPI">
						<div id="btn_login_credit" class="btn_login" @click.prevent="demo">{{ lang.demo }}</div>
					</div>
					<div class="box_remember">
						<label class="check_remember lab_radio">
						<input id="remember" type="checkbox" v-model="isRememberMe">
						<span class="checkmark"></span>
						<tt>{{ langList.login['LOGIN.LBL_REMEMBERME'] }}</tt>
						</label>
					</div>
          <template v-if="isAPI == 0 && !isP">
					  <input id="btn_pwd4"  @click.prevent="pcLogin($event)" class="btn_passcode" type="button" :value="langList.login['LOGIN.MSG_LOGIN_USING_PASSCODE']">
          </template>
        </div>
        <template v-if="centerLogin">
          <!-- <div id="div_run" class="box_img_HG" :class="cookielang">
            <div class="img_ip_HG">
              <a id="ip_run" :href="centerLoginLink()" target="_blank">
                <span id="run_ip">{{ getCenterLoginDomain() }}</span>
              </a>
              <a id="ip_guide" class="btn_ipguide" :href="sysReqClick(1)"></a>
            </div>
          </div> -->
          <div class="box_browser">
            <span>{{ lang.browserRecomm }}</span>
            <div class="wrap_browser">
              <div id="browse_CHR" class="btn_browser">
                <i class="icon_CHR" @click="browserClick(1)"></i>
                <span>{{ lang.browserChrome}}</span>
              </div>
              <div id="browse_SAF" class="btn_browser">
                <i class="icon_SAF" @click="browserClick(2)"></i>
                <span>{{ lang.browserSafari}}</span>
              </div>
              <div id="browse_FOX" class="btn_browser">
                <i class="icon_FOX" @click="browserClick(3)"></i>
                <span>{{ lang.browserFirefox}}</span>
              </div>
            </div>
            <p v-html="browserMinReqText()"></p>
          </div>
        </template>
        
				<!--<div class="LayoutLogin desk-ver-btn">
					<i class="fa fa-desktop" aria-hidden="true"></i>
					<a id="login_btn" class="desk-btn" style="background-color:" @click.prevent="desktop">{{ lang.desktopVer }}</a>
				</div>-->
			</div>
			<div class="push"></div>
		</div>
                <div id="sysreq_show" class="sys" style="display: none;">
                   <div class="title_sys">
         	      <div id="go_back" class="btn_back"><img id="irightarr" src="assets/images/icon_rightarr.svg"></div>
      		   </div>
      		<div class="content_sys"></div>
    </div>
	</div>
	</div>
</template>

<script>
import core from '@/js/core/core'
import popup from '../../components/popup.vue'
import EventBus from '@/vue/events/event-bus'
import loadingScreen from '@/vue/components/loadingScreen'
import vueCookie from 'vue-cookie'
import popupFestival from '../../components/popup-festival'

export default {
  components: {
      popup,
      loadingScreen,
      popupFestival,
    },
  data() {
    return {
      isRememberMe: false,
      loading: false,
      langSelect: lang_select,
      cookielang: _cookie,
      lang: lang,
      langList: langList,
      formData: {
        accname: '',
        pass: '',
      },
      error: {
        loginIdReq: false,
        message: '',
      },
      currentTemplate: window._currentTemplate,
      customTemplate: window._customTemplate,
      companycode : window.compcode,
      inputLength: window._inputLength,
      showDemo: window.showDemo,
      showLogo: window.showLogo,
      popupFlag: false,
      emptytoken :window.emptytoken,
      showCreditDemoFlag:window.showCreditDemoFlag,
      UID: JSON.parse(vueCookie.get('UID')),
      isAPI: isAPI,
      isP: true,
      token :window.token,
      centerLogin: window.centerLogin,
      tableData:tableData,
    }
  },
  computed: {
  },
  methods: {
    desktop(){
      var redirect = window._baseUrl.replace(window._mobileTemplate,window._webTemplate)+'/login?desktop=1';
      window.location.href = redirect
    },
    demoLogin(){
      this.$ajax({
        method: 'post',
        url: window.demoLogin,
        data: {}
      }).done(((res)=> {
        //window.location.href = res.redirect
      }).bind(this)).catch((errRes)=> {
          console.log(errRes)
      })
    },
    login() {
      if (this.formData.accname == '') {
        this.error.loginIdReq = true
        this.error.message = this.lang.emptyLoginId
        $('#usr_lab').addClass('error').removeClass('on')
        $('#pwd_lab').removeClass('on')
      } else if (this.formData.pass == '') {
        this.error.loginIdReq = true
        this.error.message = this.lang.emptyPassword
        $('#usr_lab').removeClass('error').removeClass('on')
        $('#pwd_lab').addClass('error').removeClass('on')
      } else {
        if(this.isRememberMe) {
          this.$cookie.set(window.compcode + '_remember', JSON.stringify({
            accname: this.formData.accname,
            isRememberMe: this.isRememberMe
          }))
        }
        this.error.loginIdReq = false
        this.loading = true
        this.formData.token = token.arr_9+'|'+this.formData.accname
        this.$ajax({
          method: 'post',
          url: '',
          data: this.formData,
        }).catch(error => {
          this.loading = false
          this.error.loginIdReq = true
          this.error.message = error.responseJSON.message
        })
      }
    },
    handleEnterKey(event) {
      if (event.keyCode === 13) {
        this.login();
      }
    },
    changeLanguage: function(value) {
      this.loading = true
      this.$ajax({
        url: '',
        type: 'get',
        data: {
          language: value,
          token: token.arr_3,
        },
      }).then(response => {
        window.location.reload();
      })
    },
    langClass(lang) {
      if (lang == this.cookielang) {
        return 'btn_language on';
      }
      return 'btn_language';
    },
    demo(){
          this.popupFlag = true;
    },
    pcLogin(){
      if(!vueCookie.get('UID')){
        this.error.loginIdReq = true
        this.error.message = this.langList.login['LOGIN.ERR_MSG_PASSCODE_REMOVED']
        this.isP = true
        return
      }
      var arr = {}
      arr['usrn'] = JSON.parse(vueCookie.get('UID')).usrn
      // arr['usrn'] = account.usrn
      arr['nsid'] = JSON.parse(vueCookie.get('UID')).nsid
      arr['page'] = '1' //passcode login
      vueCookie.set('UID', JSON.stringify(arr))
      window.location.href = 'login'
    },
    input_Green: function(value){
      if(value == 1) {
           $('#usr_lab').addClass('on');
           $('#pwd_lab').removeClass("on");
      } else if(value == 2) {
           $('#pwd_lab').addClass('on');
           $('#usr_lab').removeClass("on");
      } else {
           $('#usr_lab').removeClass("on");
           $('#pwd_lab').removeClass("on");
      }
    },
    input_Clear: function(value){
      if(value == 1) {
           $('#usr').val('');
      } else if(value == 2) {
           $('#pwd').val('');
      }
    },
    defaultLogo() {
      if(this.customTemplate && !this.customTemplate['logo_mhg']){
        return 'index_top_pic'
      }
    },
    
    centerLoginLink() {
      return this.centerLogin.domain + this.centerLogin.path;
    },
    getCenterLoginDomain() {
      // return Object.keys(this.centerLogin)[0];
      const url = new URL(this.centerLogin.domain);
      const domain = url.hostname;
      return domain;
    },
    browserMinReqText() {
      const minReqText = '<a id="sysReq">'+this.lang.browserMinReq+'</a>';
      const replacedText = this.lang.browserMinReqMsg.replace('{minReq}', minReqText);
      return replacedText;
    },
    sysReqClick: function() {
      $('#body_show').hide();
      $('#sysreq_show').show();
      $('.content_sys').css('padding-top', '80px');

      const title_sys = $('<span>').text( this.lang.minimum);
      $('.title_sys').children().filter(':not(#go_back, img)').remove();
      $('.title_sys').append(title_sys);
      const box_sys = $('<div>').addClass('box_sys');
      const description1 = $('<span>').addClass('text_sys').text(this.lang.sysMinDesc1);
      const description2 = $('<span>').addClass('subtitle_sys').text( this.lang.sysMinDesc2);
      const description3 = $('<p>').text( this.lang.sysMinDesc3);
      const back_button = $('<div>').attr({
        'id': 'go_back_bottom',
        'class': 'btn_sys',
      }).text( this.lang.sysMinDesc4);

      box_sys.append(description1);
      $.each( this.tableData['TABLE'], function (key1, value1) {
        const subtitle = $('<span>').addClass('subtitle_sys').text(key1);
        box_sys.append(subtitle);
        $.each(value1, function (key2, value2) {
          const table = $('<table>').addClass('table_sys');
          const tbody = $('<tbody>');
          const tr_th = $('<tr>').addClass('table_sys_title');
          $.each(value2.th, function (key3, value3) {
            const th = $('<th>').text(value3);
            tr_th.append(th);
          });
          tbody.append(tr_th);
          $.each(value2.td, function (key4, value4) {
            const tr_td = $('<tr>');
            $.each(value4, function (key5, value5) {
              const td = $('<td>').html(value5);
              tr_td.append(td);
            });
            tbody.append(tr_td);
          });
          table.append(tbody);
          box_sys.append(table);
        });
      });
      box_sys.append(description2, description3, back_button);
      $('.content_sys').empty().append(box_sys);

      $('#go_back_bottom, #go_back').click(function (e) {
        e.preventDefault();
        $('#body_show').show();
        $('#sysreq_show').hide();
      });

      $('.chr_link').click(function (e) {
        window.open('https://www.google.com/chrome/', '_blank');
      });
      $('.saf_link').click(function (e) {
        window.open('https://support.apple.com/downloads/safari', '_blank');
      });
      $('.qq_link').click(function (e) {
        window.open('https://browser.qq.com/', '_blank');
      });
      $('.fox_link').click(function (e) {
        window.open('https://www.mozilla.org/', '_blank');
      });
    },

    setupClickEvent: function() {
    const sysReqElement = document.getElementById('sysReq');
    const self = this;
    if (sysReqElement) {
        sysReqElement.addEventListener('click', function() {
            self.sysReqClick();
        });
    };
  },
    browserClick: function(value) {
      const browser_links = {
        1: 'https://www.google.com/chrome/',
        2: 'https://support.apple.com/downloads/safari',
        3: 'https://www.mozilla.org/',
      };
      window.open(browser_links[value], '_blank');
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleEnterKey);
    this.loading = false
    $('#username').focus();
    if(vueCookie.get('UID')){
      var cookieUID = JSON.parse(vueCookie.get('UID'))
      if (cookieUID.usrn != -1) {
        var arr = {}
        // arr['usrn'] = cookieUID.usrn
        arr['usrn'] = cookieUID.usrn
        arr['nsid'] = cookieUID.nsid
        arr['page'] = '1' //passcode login
        vueCookie.set('UID', JSON.stringify(arr))
      }
    }
    EventBus.$on('setDemoFlag', (res)=> {
          this.popupFlag = res;
    })

    if(this.centerLogin) {
      const scrollStyle1 = document.createElement('style');
      scrollStyle1.innerHTML = `
        ::-webkit-scrollbar {
          width: 4px;
        }
      `;
      const scrollStyle2 = document.createElement('style');
      scrollStyle2.innerHTML = `
        ::-webkit-scrollbar-thumb {
          background: #ccc;
        }
      `;
      $('head').append(scrollStyle1,scrollStyle2);
      $('.login_main').css({
        'background':'#f5f5f5',
        'height':'auto',
      });
      $('.box_login').css({
        'margin':'16px auto',
        'box-shadow':'0 0 0 0 transparent',
        'padding':'24px 16px 16px 16px',
      });
      $('.box_browser').css({
        'box-shadow':'0 0 0 0 transparent',
      });
    }
    document.addEventListener('DOMContentLoaded', this.setupClickEvent);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleEnterKey);
  },
  beforeMount() {
    localStorage.removeItem('bts')
    var cookieRemember = this.$cookie.get(window.compcode + '_remember')
    if(cookieRemember) {
      cookieRemember = JSON.parse(cookieRemember)
      this.isRememberMe = cookieRemember.isRememberMe
      if(cookieRemember.isRememberMe) {
        this.formData.accname = cookieRemember.accname
      }
    }
    if(vueCookie.get('UID') && JSON.parse(vueCookie.get('UID')).usrn) {
      var usrn = JSON.parse(vueCookie.get('UID')).usrn
      if(usrn == '-1' || !JSON.parse(vueCookie.get('UID')).nsid){
        this.isP = true
      } else {
        this.isP = false
      }
    }
    if(vueCookie.get('PC_RMV')) {
      this.error.loginIdReq = true
      this.error.message = vueCookie.get('PC_RMV')
      vueCookie.delete('PC_RMV')
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/base/global";
@import "~@/styles/auth/login";

</style>



// WEBPACK FOOTER //
// resources/mhg/vue/apps/auth/login.vue